// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2gtHs","title":"Header_title__h72rJ","left":"Header_left__1Ss4f","clinicName":"Header_clinicName__RfP7T"};